import styled from 'styled-components';
import { media } from '@minecraft.themes';

export const Wrapper = styled.div`
  background-color: ${({ theme }): string => theme.designSystem.bgColors.presentationWrapper};
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const CTAItemLabel = styled.div`
  font-size: 1rem;
  font-weight: 500;
  color: ${(props): string => props.theme.colors.primary.darkGrey};
  margin-bottom: 0.25rem;

  ${media.sm`
    font-size: 0.875rem;
  `}
`;

export const FolderNameLabel = styled.div`
  color: ${(props): string => props.theme.colors.primary.grey1};
  font-size: 0.625rem;
  text-transform: uppercase;
`;

export const FolderNameText = styled.div`
  font-size: 1.25rem;
  font-weight: 500;
`;

export const TalentCount = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  margin-top: 1rem;
`;
